import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import dashboardEn from "./en/dashboardEn";
import masterEn from "./en/masterEn";
import settingsEn from "./en/settings";
import usersEn from "./en/users";
import premisesEn from "./en/premisesEn";
import reportEn from "./en/reportEn";
import communicationEn from "./en/communicationEn";
import visitorManagementEn from "./en/visitorManagementEn";
import helpDeskEn from "./en/helpDeskEn";
import notificationsEn from "./en/notificationsEn";
import financeEn from "./en/financeEn";
import maintenanceEn from "./en/maintenanceEn";
import amenitiesEn from "./en/amenitiesEn";
import documentsEn from "./en/documentsEn";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...dashboardEn,
            ...masterEn,
            ...settingsEn,
            ...usersEn,
            ...premisesEn,
            ...reportEn,
            ...communicationEn,
            ...visitorManagementEn,
            ...helpDeskEn,
            ...notificationsEn,
            ...financeEn,
            ...maintenanceEn,
            ...amenitiesEn,
            ...documentsEn,
        }
    },
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;